import { useState } from "react";
import { FormTextArea } from "../../../components/Input/FormTextArea";
import { FormNumber } from "../../../components/Input/FormNumber";
import { CommonUserTaskNew } from "../CommonUserTaskNew";
import type { ComponentConfig } from "../types";
import ErrorMessages from "../../../components/ErrorMessages/ErrorMessage";

interface FormData {
  hours: number;
  minutes: number;
  note: string;
}

const NoReply = ({ task, save, trigger }: any) => {
  const defaultHours = task?.defaults?.timeOut?.hours ?? 4;
  const defaultMinutes = task?.defaults?.timeOut?.minutes ?? 0;
  const loadedData: FormData = {
    hours: task?.data?.hours ?? defaultHours,
    minutes: task?.data?.minutes ?? defaultMinutes,
    note: task?.data?.note ?? "",
  };

  const [formData, setFormData] = useState<FormData>(loadedData);
  const [errorMessages, setErrorMessages] = useState<string>("");

  function handleFormUpdate(name: string, value: any): void {
    setFormData((prevState) => ({ ...prevState, [name]: value }));
  }

  function handleComplete(): void {
    trigger(
      formData,
      () => { },
      (e: any) => setErrorMessages(e?.detail)
    );
  }

  function handleSave(): void {
    save(
      formData,
      () => { },
      (e: any) => setErrorMessages(e?.detail)
    );
  }

  const formConfig: ComponentConfig[] = [
    {
      component: (
        <div>
          <p style={{ margin: "0 0 0.5rem 0", padding: "0 1rem 1rem 1rem", color: "#666" }}>
            Set how long the case should be hidden from the "Direct channel - not signed" queue before it reappears.
          </p>
          <div style={{ display: "flex", gap: "0.5rem" }}>
            <div style={{ flex: 1, minWidth: 0 }}>
              <FormNumber
                label="Hours"
                name="hours"
                value={formData.hours}
                onChange={(value) => handleFormUpdate("hours", Number(value))}
                placeholder="0 - 167"
                min={0}
                max={167}
                required
              />
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <FormNumber
                label="Minutes"
                name="minutes"
                value={formData.minutes}
                onChange={(value) => handleFormUpdate("minutes", Number(value))}
                placeholder="0 - 59"
                min={0}
                max={59}
                required
              />
            </div>
          </div>
        </div>
      ),
      order: 1,
    },
    {
      component: (
        <FormTextArea
          name="note"
          onChange={(value: string) => handleFormUpdate("note", value)}
          label="Note (optional)"
          defaultValue={formData.note}
          placeholder="Note about the attempted contact"
        />
      ),
      order: 2,
    },
    {
      component: <ErrorMessages errors={[errorMessages]} />,
      order: 3,
      hide: errorMessages === "",
    },
  ];

  return (
    <CommonUserTaskNew
      handleComplete={handleComplete}
      handleSave={handleSave}
      formConfig={formConfig}
      overrideMasonryColumns={1}
    />
  );
};

export default NoReply;
